import { useMutation, useQueryClient } from "@tanstack/react-query";
import { unlockLogin } from "@/api/monitor";
import { MonitorQueryKeys } from "@/tanstackQuery/queries/monitor";

export const useUnlockLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (username: string) => unlockLogin(username),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MonitorQueryKeys.LoginSecurity],
      });
    },
  });
};
